import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faAngleUp,
  faArrowDown,
  faSave,
  faTimes,
  faGrinTongueSquint,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect } from "react-router-dom";
import { BrowserRouter as Router, withRouter, Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Select from "react-select";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class LeaseOccupier extends React.Component {
  // mainFormValidator = [];
  state = {
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    companyName: [],
    vendor_code: "",
    tower: [],
    occupierGroups: [],
    // brandCategory: [],
    // brandSubCategories: [],
    gstStates: [],
    members:[],
    brands: [],
    brandSelected: [],
    redirect: false,
    franchiseeDetails: false,
    franchiseeGstStateCode: "",
    franchiseeGstState: "",
    selectedCompanies: [],
    initialValues: {
      leaseCreationDate: "",
      leaseId: "",
    },
    brandId: [],
    occupiers: [],
    cityList: [],
    occupierCount: 1,
    // brandCategoryName: "",
    // brandCategoryId: "",
    // brandSubCategoryName: "",
    // brandSubCategoryId: "",
    brandName: "",
    occupierChargeable: [
      { name: "No", value: "0" },
      { name: "Yes", value: "1" },
    ],
    occupierMaxCharge: 100,
    percentage_message: "",
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  componentDidMount() {
    //fetch(`${apiUrl.apiUrl.url}/occupier-groups`)
    fetch(`${apiUrl.apiUrl.url}/occupier-group/fetch-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          occupierGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brands: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/user/get-occupier-contacts`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          members: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
    });  

    fetch(`${apiUrl.apiUrl.url}/states/country-states/1`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          gstStates: data,
        });

        let athis=this;
        axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-occupier-form?id=${this.props.match.params.id}`).then((response) => {
          let data=response.data;
          athis.setState({
            initialValues: data,
            occupiers: data.occupier,
            occupierCount: data.occupier.length > 0 ? data.occupier.length : 1,
            // occupierCount: data.occupier.length,
            franchiseeGstState: data.franchiseeGstState,
            franchiseeGstStateCode: data.franchiseeGstStateCode,
            brandSelected: data.brandArr,
            brands: data.brands,
            brandId: data.brandId,
            cityList: data.city_list,
          });

          let chargeableRemaining = 0;

          for (let i = 0; i < data.occupier.length; i++) {
            let find = data.occupier[i].gstNumber.substring(0, 2);
            var state = athis.state.gstStates.find((x) => x.gst_code == find);
            if (
              typeof state != "undefined" &&
              typeof state.id != "undefined"
            ) {
              athis.state.occupiers[i].gstState = state.id;
              athis.state.occupiers[i].gstStateCode = state.gst_code;
            } else {
              athis.state.occupiers[i].gstState = "";
              athis.state.occupiers[i].gstStateCode = "";
            }

            //athis.state.occupiers[i].vendorCode = state.vendor_code;
            let obj = athis.state.occupierGroups.find(
              (o) => o.id == data.occupier[i].companyGroup
            );
            console.log(data.occupier[i].companyGroup);
            athis.state.occupiers[i].companyGroupName = obj.group_name;

            chargeableRemaining =
              chargeableRemaining +
              data.occupier[i].occupier_chargeable_percentage;
          }

          console.log("Available Charge: " + chargeableRemaining);
          athis.state.occupierMaxCharge = 100 - chargeableRemaining;
          console.log(
            "Final Available Charge: " + athis.state.occupierMaxCharge
          );

          let label = data.leaseType;
          console.log(label, "label");
          let checkValue = label.includes("F");
          let cofoCheck = label.includes("Cofo");
          if (checkValue || cofoCheck) {
            athis.setState({
              franchiseeDetails: true,
            });
          } else {
            athis.setState({
              franchiseeDetails: false,
            });
          }
        });

        // fetch(
        //   `${apiUrl.apiUrl.url}/create-lease/fetch-occupier-form?id=${this.props.match.params.id}`,
        //   { headers }
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       initialValues: data,
        //       occupiers: data.occupier,
        //       occupierCount: data.occupier.length > 0 ? data.occupier.length : 1,
        //       // occupierCount: data.occupier.length,
        //       franchiseeGstState: data.franchiseeGstState,
        //       franchiseeGstStateCode: data.franchiseeGstStateCode,
        //       brandSelected: data.brandArr,
        //       brands: data.brands,
        //       brandId: data.brandId,
        //       cityList: data.city_list,
        //     });

        //     let chargeableRemaining = 0;

        //     for (let i = 0; i < data.occupier.length; i++) {
        //       let find = data.occupier[i].gstNumber.substring(0, 2);
        //       var state = this.state.gstStates.find((x) => x.gst_code == find);
        //       if (
        //         typeof state != "undefined" &&
        //         typeof state.id != "undefined"
        //       ) {
        //         this.state.occupiers[i].gstState = state.id;
        //         this.state.occupiers[i].gstStateCode = state.gst_code;
        //       } else {
        //         this.state.occupiers[i].gstState = "";
        //         this.state.occupiers[i].gstStateCode = "";
        //       }

        //       //this.state.occupiers[i].vendorCode = state.vendor_code;
        //       let obj = this.state.occupierGroups.find(
        //         (o) => o.id == data.occupier[i].companyGroup
        //       );
        //       console.log(data.occupier[i].companyGroup);
        //       this.state.occupiers[i].companyGroupName = obj.group_name;

        //       chargeableRemaining =
        //         chargeableRemaining +
        //         data.occupier[i].occupier_chargeable_percentage;
        //     }

        //     console.log("Available Charge: " + chargeableRemaining);
        //     this.state.occupierMaxCharge = 100 - chargeableRemaining;
        //     console.log(
        //       "Final Available Charge: " + this.state.occupierMaxCharge
        //     );

        //     let label = data.leaseType;
        //     console.log(label, "label");
        //     let checkValue = label.includes("F");
        //     let cofoCheck = label.includes("Cofo");
        //     if (checkValue || cofoCheck) {
        //       this.setState({
        //         franchiseeDetails: true,
        //       });
        //     } else {
        //       this.setState({
        //         franchiseeDetails: false,
        //       });
        //     }
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  changeOccupier = (e, id) => {
    this.state.occupiers[id].companyGroupName = e.label;
    this.state.occupiers[id].companyGroup = e.value;
    console.log(this.state.occupiers[id], "occupier details");
    //this.getGSTDetails(_landlords[id]["companyName"], _landlords[id]["gstState"], id )

    this.setState({});
    console.groupEnd();
    this.setState({});
    fetch(
      `${apiUrl.apiUrl.url}/occupier/get-group-companies/?id=` +
      this.state.occupiers[id].companyGroup,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let _occupiers = this.state.occupiers;
        _occupiers[id].companies = data;
        this.setState({
          occupiers: _occupiers,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeChargeable = (e, id) => {
    console.log(e.label + "...." + e.value);
    this.state.occupiers[id].is_occupier_chargeable_label = e.label;
    this.state.occupiers[id].is_occupier_chargeable = e.value;
    if (e.value == 0) {
      this.state.occupiers[id].occupier_chargeable_percentage = 0;
    }
    this.setState({});
    // console.groupEnd();
    // this.setState({});
  };

  checkPercentage = (id, value) => {
    let totalPercentage = 0;
    this.state.percentage_message = "";
    for (let i = 0; i < this.state.occupiers.length; i++) {
      totalPercentage += parseInt(
        this.state.occupiers[i].occupier_chargeable_percentage
      );
      console.log(this.state.occupiers[i].occupier_chargeable_percentage);
    }
    console.log(totalPercentage);
    if (totalPercentage > 100) {
      this.state.percentage_message =
        "Occupier total percentage must be less then or equal to 100";
      this.state.occupiers[id].occupier_chargeable_percentag = 0;
      this.setState({});
    }
  };

  changeBrandName = (e) => {
    this.state.brandSelected = [];
    this.state.brandId = [];
    for (let i = 0; i < e.length; i++) {
      this.state.brandId.push(e[i].value);
      this.state.brandSelected.push({
        value: e[i].value,
        label: e[i].label,
      });
    }

    console.log(this.state.initialValues, "this.state.initialValues");
    this.setState({});
  };

  autoSelectGstState(e, i) {
    if (e.target.value !== "") {
      let find = e.target.value.substring(0, 2);
      var state = this.state.gstStates.find((x) => x.gst_code == find);
      this.state.occupiers[i].gstState = state.id;
      this.state.occupiers[i].gstStateCode = state.gst_code;
      this.setState({});
      console.log(state, "Ev");
    }
  }

  autoSelectFranchiseeGstState(e) {
    let find = e.target.value.substring(0, 2);
    var state = this.state.gstStates.find((x) => x.gst_code == find);
    this.state.franchiseeGstState = state.id;
    this.state.franchiseeGstStateCode = state.gst_code;
    this.setState({});
    console.log(state, "Ev");
  }

  showFranchiseeDetails = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].label;
    let checkValue = label.includes("F"); //label.includes("Franchisee");
    let cofoCheck = label.includes("Cofo");
    if (checkValue || cofoCheck) {
      this.setState({
        franchiseeDetails: true,
      });
    } else {
      this.setState({
        franchiseeDetails: false,
      });
    }
  };

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };
  redirectToClose = () => {
    this.setState({
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  getGSTDetails(company_id, state_id, id) {
    var url = `${apiUrl.apiUrl.url}/create-lease/get-occupier-gst-details?company_id=${company_id}&state_id=${state_id}`;
    fetch(url, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.occupiers[id].gstNumber = data.gst;
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleFranchiseeCityChange = (e) => {
    this.state.initialValues.franchiseeCityId = e.value;
    this.state.initialValues.franchiseeCity = e.label;
    var self = this;
    fetch(`${apiUrl.apiUrl.url}/city/city-details?city=` + e.value, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        self.state.initialValues.franchiseeStateId = data.stateArr.id;
        self.state.initialValues.franchiseeState = data.stateArr.state_name;
        self.state.initialValues.franchiseeDistrictId = data.districtArr.id;
        self.state.initialValues.franchiseeDistrict =
          data.districtArr.district_name;
        self.setState({});
      })
      .catch((error) => {
        console.log(error);
      });

    this.setState({});
  };

  handleDelete = (index) => {
    // Create a copy of the landlords array
    let _occupiers = this.state.occupiers;

    // Remove the item at the specified index
    _occupiers.splice([index - 1], 1);

    // Update the state
    this.setState({
      occupiers: _occupiers,
      occupierCount: this.state.occupierCount - 1
    });
  }

  occupierTabs(handleChange) {
    var heads = [];
    for (var i = 0; i < this.state.occupierCount; i++) {
      heads.push(<Tab>Occupier {i + 1} {heads.length < 1 ? null : <span onClick={() => this.handleDelete(i)} className="ms-2"><FontAwesomeIcon icon={faTimes} /></span>}</Tab>);
    }

    var body = [];
    for (var i = 0; i < this.state.occupierCount; i++) {
      if (
        typeof this.state.occupiers[i] === "undefined" ||
        this.state.occupiers[i] === null
      ) {
        this.state.occupiers[i] = {};
        this.state.occupiers[i].companyGroup = "";
        this.state.occupiers[i].companyName = [];
        this.state.occupiers[i].companies = [];
        this.state.occupiers[i].gstNumber = "";
        this.state.occupiers[i].gstState = "";
        this.state.occupiers[i].gstStateCode = "";
      }
      body.push(
        <TabPanel>
          <div className="unitFormContainerNew">
            <div className="newGridSectionParent px-0">
              <div className="newGridSectionForFormMain">

                <div className="newGridSectionInner">
                  <label>
                    Occupier Group <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                      isSearchable="true"
                      name={"occupier[" + i + "].companyGroup"}
                      value={{
                        label: this.state.occupiers[i].companyGroupName,
                        value: this.state.occupiers[i].companyGroup,
                      }}
                      onChange={(e, i) => {
                        var id = i.name.split("[")[1].split("]")[0];
                        this.state.occupiers[id].companyGroup = e.value;
                        this.changeOccupier(e, id);
                      }}
                      options={this.state.occupierGroups.map((item) => ({
                        label: item.group_name,
                        value: item.id,
                      }))}
                    />
                    {this.mainFormValidator.message(
                      "company Group",
                      this.state.occupiers[i].companyGroup,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>
                </div>

                <div className="newGridSectionInner">
                  <label>
                    Occupier Company Name <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <Field
                      as={"select"}
                      param={i}
                      value={this.state.occupiers[i].companyName}
                      name={"occupier[" + i + "].companyName"}
                      onChange={(e) => {
                        handleChange(e);
                        var id = e.target.getAttribute("param");
                        this.state.occupiers[id].companyName = e.target.value;
                        if (
                          this.state.selectedCompanies.indexOf(e.target.value) > -1
                        ) {
                          this.setState({
                            popupalertMessage: true,
                            popupMessageContent: "Please Select another company",
                          });
                        } else {
                          this.state.occupiers[id].companyName = e.target.value;
                          this.state.selectedCompanies[id] = this.state.occupiers[id].companyName;
                        }
                      }}
                    >
                      <option value="" label="Select" defaultValue />
                      {this.state.occupiers[i].companies.map((obj) => (
                        <option key={obj.id} value={obj.id}>
                          {obj.company_name}
                        </option>
                      ))}
                    </Field>
                    {this.mainFormValidator.message(
                      "company Name",
                      this.state.occupiers[i].companyName,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>
                </div>

                <div className="newGridSectionInner">
                  <label>
                    Occupier GST State & GST State Code
                  </label>
                  <div className="position-relative">
                    <div className="row m-0">
                      <div className="col-sm-6 ps-0">
                        <select
                          param={i}
                          value={this.state.occupiers[i].gstState}
                          name={"occupier[" + i + "].gstState"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            var state = this.state.gstStates.find(
                              (x) => x.id == e.target.value
                            );
                            var _occupiers = this.state.occupiers;
                            _occupiers[id].gstStateCode = state.gst_code;

                            this.setState({
                              occupiers: _occupiers,
                            });
                            this.state.occupiers[id].gstState = e.target.value;

                            this.getGSTDetails(
                              _occupiers[id]["companyName"],
                              _occupiers[id]["gstState"],
                              id
                            );

                            this.setState({});
                            handleChange(e);
                          }}
                        >
                          <option value="" label="Select" defaultValue />
                          {this.state.gstStates.map((obj) => (
                            <option key={"gstState" + obj.id} value={obj.id}>
                              {obj.state_name}
                            </option>
                          ))}
                        </select>
                        <ErrorMessage
                          name={"occupier[" + i + "].gstState"}
                          component="div"
                          className="text-red"
                        />
                      </div>
                      <div className="col-sm-6 pe-0">
                        <Field
                          param={i}
                          value={this.state.occupiers[i].gstStateCode}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            handleChange(e);
                            this.state.occupiers[id].gstStateCode =
                              e.target.value;
                          }}
                          type="text"
                          name={"occupier[" + i + "].gstStateCode"}
                        />
                        <ErrorMessage
                          name={"occupier[" + i + "].gstStateCode"}
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="newGridSectionInner">
                  <label>
                    GST Number
                  </label>
                  <div className="position-relative">
                    <Field
                      param={i}
                      value={this.state.occupiers[i].gstNumber}
                      type="text"
                      name={"occupier[" + i + "].gstNumber"}
                      onChange={(e) => {
                        handleChange(e);
                        var id = e.target.getAttribute("param");
                        this.state.occupiers[id].gstNumber = e.target.value;
                      }}
                      onBlur={(e) => {
                        var i = e.target.getAttribute("param");
                      }}
                    />
                  </div>
                </div>

                <div className="newGridSectionInner">
                  <label>
                    Is Occupier Chargeable <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                      isSearchable="true"
                      name={"occupier[" + i + "].is_occupier_chargeable"}
                      value={{
                        label: this.state.occupiers[i].is_occupier_chargeable_label,
                        value: this.state.occupiers[i].is_occupier_chargeable,
                      }}
                      onChange={(e, i) => {
                        let id = i.name.split("[")[1].split("]")[0];
                        this.state.occupiers[id].is_occupier_chargeable = e.value;
                        this.changeChargeable(e, id);
                      }}
                      options={this.state.occupierChargeable.map((item) => ({
                        label: item.name,
                        value: item.value,
                      }))}
                    />
                    {this.mainFormValidator.message(
                      "company chargeable",
                      this.state.occupiers[i].is_occupier_chargeable,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>
                </div>

                <div className="newGridSectionInner">
                  <label>
                    SPOC
                  </label>
                  <div className="position-relative">
                    <select
                      param={i}
                      value={this.state.occupiers[i].member}
                      name={"occupier[" + i + "].member"}
                      onChange={(e, i) => {
                        handleChange(e);
                        var id = e.target.getAttribute("param");
                        console.log(id, "asdasd",this.state.occupiers[id]);
                        this.state.occupiers[id].member = e.target.value;
                      }}
                    >
                      <option value="" label="Select" defaultValue />
                      { typeof this.state.members[this.state.occupiers[i]["companyName"]] != "undefined" && this.state.members[this.state.occupiers[i]["companyName"]].map((obj) => (
                        <option key={"member" + obj.id} value={obj.id}>
                          {obj.name}
                        </option>
                      ))}
                    </select>
                    
                  </div>
                </div>

                {this.state.occupiers[i].is_occupier_chargeable == 1 && (
                  <div className="newGridSectionInner">
                    <label>
                      Chargeable Percentage(%) <span className="astrik">*</span>
                    </label>
                    <div className="position-relative">
                      <Field
                        param={i}
                        value={this.state.occupiers[i].occupier_chargeable_percentage}
                        type="text"
                        name={"occupier[" + i + "].occupier_chargeable_percentage"}
                        onChange={(e) => {
                          handleChange(e);
                          var id = e.target.getAttribute("param");
                          this.state.occupiers[id].occupier_chargeable_percentage = e.target.value;
                          this.checkPercentage(id, e.target.value);
                        }}
                      />
                      <span>{this.state.percentage_message}</span>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </TabPanel>
      );
    }

    return (
      <div>
        <Tabs>
          <div className="row m-0 mb-3 align-items-center border-bottom-class">
            <div className="col-10 ps-0">
              <TabList>{heads}</TabList>
            </div>
            <div className="button_group col-2 text-end p-0">
              <button className="update_button"
                type="button"
                onClick={(e) => {
                  // let _occupiers = this.state.occupiers;
                  // _occupiers.splice([i - 1], 1);
                  this.setState({
                    // occupiers: _occupiers,
                    occupierCount: this.state.occupierCount + 1,
                  });
                }}>
                <FontAwesomeIcon icon={faPlus} /> Add Occupier
              </button>
            </div>
          </div>
          <div>{body}</div>
        </Tabs>
      </div>
    );
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match.path;
      let urlPath = url.split("/");
      this.state.redirect = false;
      return (
        <Redirect
          push
          //to={"/createlease/lease-term-details/" + this.props.match.params.id}
          //to={`/${urlPath[1]}/lease-term-details/`+ this.props.match.params.id}
          to={
            `/${urlPath[1]}/lease-term-details/` + this.props.match.params.id
          }
        />
      );
    }
    return (
      <div
        className="parentContainer createLease">
        <>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>Create Lease</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>Parties, Unit & Brand Details</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">Occupier & Brand Details</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              console.log(values);
              values.brandId = this.state.brandId;
              values.franchiseeGstState = this.state.franchiseeGstState;
              values.franchiseeGstStateCode =
                this.state.franchiseeGstStateCode;
              if (!this.mainFormValidator.allValid()) {
                console.log(this.mainFormValidator);
                this.mainFormValidator.showMessages();
                return false;
              }
              // return false;
              var self = this;
              axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/create-lease/update-lease-occupier?lease_id=${this.props.match.params.id}`,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.setState({ messsagePopup: true });
                }
              });
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
            }) => (
              <>
                <div className="unitFormContainerNew">
                  <Form autoComplete="off" className="customTabs">
                    <div className="newGridSectionParent">
                      <div className="newGridSectionForFormMain">

                        <div className="newGridSectionInner">
                          <label>
                            Lease Id <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="text"
                              name="leaseId"
                              readOnly="true"
                            />
                            <ErrorMessage
                              name="leaseId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Lease Creation Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="leaseCreationDate"
                              readOnly="true"
                            />
                            <ErrorMessage
                              name="leaseCreationDate"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Model Type <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              as="select"
                              name="leaseType"
                              onChange={(e) => {
                                handleChange(e);
                                this.showFranchiseeDetails(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                                  <option
                                    value="COCO"
                                    label="COCO"
                                  />
                                  <option
                                    value="COFO"
                                    label="COFO"
                                  />
                                  <option
                                    value="FOCO"
                                    label="FOCO"
                                  />
                                  <option
                                    value="FOFO"
                                    label="FOFO"
                                  />
                                  <option
                                    value="FOCL"
                                    label="FOCL"
                                  />
                                  <option
                                    value="FICO"
                                    label="FICO"
                                  />
                                  <option
                                    value="tripartite"
                                    label="Tripartite"
                                  />
                            </Field>
                            {this.mainFormValidator.message(
                              "lease Type",
                              values.leaseType,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Cost Centre / Branch Code
                          </label>
                          <div className="position-relative">
                            <Field type="text" name="costCenter" />
                            <ErrorMessage
                              name="costCenter"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Brand Name
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="brandId"
                              isMulti
                              closeMenuOnSelect={false}
                              onInputChange={this.handleChange}
                              onChange={(e) => {
                                this.changeBrandName(e);
                              }}
                              value={this.state.brandSelected}
                              options={this.state.brands.map((item) => ({
                                label: item.brand_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="brandId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            New / Renewal
                          </label>
                          <div className="position-relative">
                            <Field
                              as="select"
                              name="renewalType"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="Fresh" label="Fresh" />
                              <option value="Rolling Renewal" label="Rolling Renewal" />
                              <option value="Fresh Renewal" label="Fresh Renewal" />
                            </Field>
                            {this.mainFormValidator.message(
                              "lease Type",
                              values.leaseType,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            No. of Occupiers
                          </label>
                          <div className="position-relative">
                            <Field
                              className="disable"
                              type="text"
                              name="occupierCount"
                              value={this.state.occupierCount}
                              onChange={(e) => {
                                if (!isNaN(e.target.value)) {
                                  this.setState({
                                    occupierCount: e.target.value,
                                  });
                                }
                              }}
                            />
                            <ErrorMessage
                              name="occupierCount"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                        <div className="gridColOneByThree">
                          {this.occupierTabs(handleChange)}
                        </div>
                        {this.state.franchiseeDetails && (
                          <>
                            {/* <div className="unitFormContainerNew">
                              <div className="newGridSectionParent">
                                <div className="newGridSectionForFormMain"> */}

                            <div className="newGridSectionInner">
                              <label>
                                Franchisee Name <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="text"
                                  name={"franchiseeName"}
                                />
                                <ErrorMessage
                                  name={"franchiseeName"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Response ID <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="text"
                                  name={"franchiseeResponseId"}
                                />
                                <ErrorMessage
                                  name={"franchiseeResponseId"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Franchisee GST Number <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name={"franchiseeGstNumber"}
                                  onBlur={(e) => {
                                    var i = e.target.getAttribute("param");
                                    this.autoSelectFranchiseeGstState(e, i);
                                  }}
                                />
                                <ErrorMessage
                                  name={"franchiseeGstNumber"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Franchisee GST State & GST State Code <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-8 ps-0">
                                    <Field
                                      as={"select"}
                                      name={"franchiseeGstState"}
                                      value={this.state.franchiseeGstState}
                                      onChange={(e) => {
                                        var state = this.state.gstStates.find((x) => x.id == e.target.value);
                                        this.state.franchiseeGstState = e.target.value;
                                        this.state.franchiseeGstStateCode = state.gst_code;
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      {this.state.gstStates.map((obj) => (
                                        <option key={"gstState" + obj.id} value={obj.id}>
                                          {obj.state_name}
                                        </option>
                                      ))}
                                    </Field>
                                    <ErrorMessage
                                      name={"franchiseeGstState"}
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                  <div className="col-4 pe-0">
                                    <Field
                                      onChange={(e) => {
                                        this.state.franchiseeGstStateCode = e.target.value;
                                        handleChange(e);
                                      }}
                                      value={this.state.franchiseeGstStateCode}
                                      type="text"
                                      name={"franchiseeGstStateCode"}
                                    />
                                    <ErrorMessage
                                      name={"franchiseeGstStateCode"}
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>

                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Start Date <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="date"
                                  name={"startDate"}
                                />
                                <ErrorMessage
                                  name={"startDate"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                End Date <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="date"
                                  name={"endtDate"}
                                />
                                <ErrorMessage
                                  name={"endtDate"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Vendor Code <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="text"
                                  name={"vendorCode"}
                                />
                                <ErrorMessage
                                  name={"vendorCode"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Address <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="text"
                                  name={"registeredOffice"}
                                />
                                <ErrorMessage
                                  name={"registeredOffice"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                City <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Select
                                  className="basic-single custom-select-style"
                                  classNamePrefix="custom-select-style-inner"
                                  isSearchable="true"
                                  name={"franchiseeCity"}
                                  value={{
                                    label: this.state.initialValues.franchiseeCity,
                                    value: this.state.initialValues.franchiseeCityId,
                                  }}
                                  onChange={(e, i) => {
                                    this.handleFranchiseeCityChange(e);
                                  }}
                                  options={this.state.cityList.map((item) => ({
                                    label: item.city_name,
                                    value: item.id,
                                  }))}
                                />
                                <ErrorMessage
                                  name={"franchiseeCity"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                District <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Select
                                  className="basic-single custom-select-style"
                                  classNamePrefix="custom-select-style-inner"
                                  isSearchable="true"
                                  name={"franchiseeDistrict"}
                                  value={{
                                    label: this.state.initialValues.franchiseeDistrict,
                                    value: this.state.initialValues.franchiseeDistrictId,
                                  }}
                                />
                                <ErrorMessage
                                  name={"franchiseeDistrict"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                State <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Select
                                  className="basic-single custom-select-style"
                                  classNamePrefix="custom-select-style-inner"
                                  isSearchable="true"
                                  name={"franchiseeState"}
                                  value={{
                                    label: this.state.initialValues.franchiseeState,
                                    value: this.state.initialValues.franchiseeStateId,
                                  }}
                                  onChange={(e, i) => { }}
                                />
                                <ErrorMessage
                                  name={"franchiseeState"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Pincode <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="text"
                                  name={"franchiseePincode"}
                                />
                                <ErrorMessage
                                  name={"franchiseePincode"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Target Linked Incentive (TLI) <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="number"
                                  name={"franchiseeCommission"}
                                />
                                <ErrorMessage
                                  name={"franchiseeCommission"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Agreement date <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="date"
                                  name={"agreementDate"}
                                />
                                <ErrorMessage
                                  name={"agreementDate"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Commission % on Regular <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="number"
                                  name={"commisionOnRegular"}
                                />
                                <ErrorMessage
                                  name={"commisionOnRegular"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Commission % on EOSS <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="number"
                                  name={"commisionOnEOSS"}
                                />
                                <ErrorMessage
                                  name={"commisionOnEOSS"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Security Deposit <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="number"
                                  name={"securityDeposit"}
                                />
                                <ErrorMessage
                                  name={"securityDeposit"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Stock Correction <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="number"
                                  name={"stockCorrection"}
                                />
                                <ErrorMessage
                                  name={"stockCorrection"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Discount Sharing <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  type="number"
                                  name={"discountSharing"}
                                />
                                <ErrorMessage
                                  name={"discountSharing"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Payment By <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as={"select"}
                                  name={"paymentBy"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option value="Company" label="Company" />
                                  <option value="Franchise" label="Franchise" />
                                </Field>
                                <ErrorMessage
                                  name={"paymentBy"}
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            {/* </div>
                              </div>
                            </div> */}
                          </>
                        )}
                        <div className="gridColOneByThree">
                          <span className="remarks">Notes/Remarks</span>
                          <Field as="textarea" className="notes" name="notes_2" />
                        </div>
                      </div>
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          type="submit"
                          className="add_button"
                          disabled={this.state.submitDisable}
                        >
                          Save & Next
                        </button>
                        <button type="reset" className="reset_button">
                          <Link to="/createlease">
                            Cancel
                          </Link>
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>

              </>
            )}
          </Formik>
        </>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }
}

export default withRouter(LeaseOccupier);
